module.exports = __webpack_public_path__ + "media/images/emblems/Obergerlafingen-blason-372d90652f3048339fc7937b420db438.png";